//region block: pre-declaration
//endregion
function clockMillis() {
  return Date.now();
}
//region block: exports
export {
  clockMillis as clockMillis2lf7cl1xsmoff,
};
//endregion

//# sourceMappingURL=clockMillis.mjs.map
